import themeGet from '@pyt/ui/utils/themeGet'
import styled from 'styled-components'

export const FilterWrapper = styled.div`
	display: contents;
	width: 100%;
	height: 100%;
	background-color: #fff;
	overflow-x: hidden;
	overflow-y: scroll;
	-webkit-overflow-scrolling: touch;
	transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

	.bali-alert,
	.alert {
		font-size: 12px;
		position: fixed;
		top: 64px;
		left: 0;
		width: 100%;
		background-color: #000000;
		padding: 12px;
		text-align: center;
		font-size: 12px;
		line-height: 1.41;
		letter-spacing: -0.01em;
		color: #ffffff;
	}
	.alert {
		background-color: #f1f0f0;
		color: ${themeGet('colors.black')};
		border: 0;
	}
`

export const FilterHeader = styled.div`
	position: ${props => props.position || 'absolute'};
	top: 0;
	left: 0;
	width: 100%;
	min-height: ${props => props.minHeight || '32px'};
	box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.06);
	z-index: 1;
`

export const FilterBody = styled.div`
	position: ${props => props.position || 'relative'};
	top: ${props => props.top || '0'};
	left: 0;
	bottom: ${props => props.bottom || '0'};
	width: 100%;
	padding: ${props => props.padding || '24px 32px'};
	overflow: auto;
`

export const FilterFooter = styled.div`
	top: ${props => props.top || 'auto'};
	bottom: 0;
	left: 0;
	width: 100%;
	min-height: ${props => props.minHeight || '32px'};
	padding: ${props => props.padding || '8px'};
	z-index: 10;
	background-color: ${props => props.backgroundColor};
	box-shadow: ${props =>
		props.noShadow ? 'none' : '0px -1px 7px rgba(0, 0, 0, 0.06)'};
	position: ${props => props.position || 'absolute'};
`
